// Module
var code = "<div id=\"borrarInspeccion\"> <p>{{ 'mensajes.confirma_borrar' | lang:'get':{'recurso' : 'nombres.la_inspeccion:choice:1' } }}</p> </div>";
// Exports
module.exports = code;